import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-down-arrow-information-black",
  "use": "icon-down-arrow-information-black-usage",
  "viewBox": "0 0 19.000000 10.000000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.000000 10.000000\" preserveAspectRatio=\"xMidYMid meet\" id=\"icon-down-arrow-information-black\">\n\n<g transform=\"translate(0.000000,10.000000) scale(0.100000,-0.100000)\" fill=\"#000000\" stroke=\"none\">\n<path d=\"M5 91 c-3 -5 15 -26 40 -46 49 -41 47 -41 107 14 42 37 22 45 -23 9\nl-39 -31 -39 31 c-22 18 -42 28 -46 23z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/down-arrow-information-black.svg
// module id = 125
// module chunks = 0 1 2